const Backbone = require('backbone');
const window = require('window');
const externalScriptLoader = require('externalScriptLoader');

module.exports = Backbone.View.extend({
	el: '#product-questions',
	initialize: function(options) {
		this.options = Object.assign({}, options);
		this._initBazaarvoice();
	},
	_initBazaarvoice: function() {
		if (!window.$BV) {
			this._loadBazaarScript();
		}
	},
	_loadBazaarScript: function(callback) {
		externalScriptLoader(`${window.dataLayer.bvUrl}`.replace('%s', window.dataLayer.bvDeploymentZone), () => {
			if (callback && typeof callback === 'function') {
				callback.call(this);
			}
		});
	}
});
